<template>
  <main :class="['v-view-primary', $store.getters.getIsClientData === false
    ? 'v-view-primary-upgrade' : '']">
    <OrganismTheHeader/>
    <section v-if="$route.name === 'map'">
      <OrganismEditionSectionChart/>
    </section>
    <section
      v-else
      key="editionSection"
      class="v-edition-section"
    >
      <OrganismEditionSectionNavigation/>
      <OrganismEditionSectionContent/>
    </section>
  </main>
</template>

<script>
export default {
  name: 'EditionSection',

  components: {
    OrganismEditionSectionChart: () => import('@/components/organisms/OrganismEditionSectionChart'),
    OrganismEditionSectionNavigation: () => import('@/components/organisms/OrganismEditionSectionNavigation'),
    OrganismEditionSectionContent: () => import('@/components/organisms/OrganismEditionSectionContent')
  }
}
</script>
